import React from "react";

import NewInput from "../../../../../shared/forms/NewInput";
import useSnackbar from "../../../../../shared/Snackbar/store";
import useCalulatorStore from "../../store";

const AmountInput = ({
    localAmount,
    onChangeAmount,
    setAmountError,
    zipcodeError,
    localZipcode,
    amountError,
}) => {
    const { notify } = useSnackbar();
    const [zipcodeIsValid, checkAmount] = useCalulatorStore((state) => [
        state.zipcodeIsValid,
        state.checkAmount,
    ]);

    return (
        <>
            <NewInput
                name="amount"
                placeholder="Menge in Liter"
                value={localAmount}
                onChange={onChangeAmount}
                validation="hel:amount"
                onError={() => setAmountError(true)}
                forceError={amountError}
                onErrorSolved={() => {
                    setAmountError(false);
                    if (zipcodeIsValid && !zipcodeError) {
                        // Check amount
                        checkAmount(localZipcode, localAmount, notify);
                    }
                }}
                required
            />
        </>
    );
};

export default AmountInput;
